<template lang="pug">
v-app(dark)
  v-layout(justify-center='')
    v-main
      router-view
      v-footer
        .caption 
          | By using this site you are agreeing to our 
          a( href="https://www.supportourstudents.ca/terms", target="_blank") Terms of Use 
          |  and 
          a(href="https://www.supportourstudents.ca/privacy", target="_blank") Privacy Policy 
          | Support Our Students may contact you in the future. You can unsubscribe at anytime.
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
a.primary--text {
color: #e5e9ec !important;
caret-color: #f4f4f4 !important;
}
</style>
